import './base_modal.less';

import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import FocusTrap from 'focus-trap-react';

import extend from 'lodash/extend';
import uniqueId from 'lodash/uniqueId';

// Based on 
//
// https://github.com/Legitcode/modal/blob/master/src/simple-modal.js

const IdentityComponent = props => props.children;

var styles = {};

styles.modal = {
  position: 'fixed',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  background: 'rgba(0, 0, 0, 0.6)',
  zIndex: 10000,
  opacity: 1,
  pointerEvents: 'auto',
  overflowY: 'auto'
};

class BaseModalUi extends Component {

  render() {
    const {
      modalId,
      modalStyle,
      isClosing,
      isShaking,
      style,
      className,
      children,
      Transition,
      onOuterClick
    } = this.props;

    return (
      <div 
        id={modalId}
        data-modal="true"
        style={modalStyle} 
        className="modal-backdrop"
        onClick={onOuterClick} 
      >
        <Transition>
          {
            !isClosing &&
              <div 
                key={modalId} 
                style={style}
                className={classNames(className, 'base-modal', {
                  'shaking-modal': isShaking
                })} 
              >
                { children }
              </div>
          }
        </Transition>
      </div>
    );
  }

}

class BaseModal extends Component {

  constructor() {
    super();

    this.state = {
      opacity: 1,
      display: 'block',
      visibility: 'visible',
      isClosing: false,
      shaking: false
    };

    this.doClose = this.doClose.bind(this);
    this.handleOuterClick = this.handleOuterClick.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillMount() {
    this._modalUniqueId = uniqueId('zf-modal-');

    $(document).on('keyup.' + this._modalUniqueId, (e)=> {
      if (e.keyCode == 27) { // escape key 
        this.doClose(e);
      }
    });
  }

  componentWillUnmount() {
    this.mounted = false;
    $(document).off('keyup.' + this._modalUniqueId);
  }

  doClose(event) {
    this.setState({
      isClosing: true
    });
    setTimeout(()=> {
      this.props.onRequestClose(event);

    }, this.props.closeTimeout);
  }

  handleOuterClick(event) {
    if (this.props.closeOnOuterClick === false) {
      if (event.target.id === this._modalUniqueId) {
        // shake the modal on unsuccesful outer click
        // set timeout should be whatever the animation length in the css file is
        this.setState({
          shaking: true
        }, () => {
          window.setTimeout(()=>{
            if (this.mounted) {
              this.setState({
                shaking: false
              });
            }
          }, 820);
        });
      }
      return;
    }
    if (event.target.id === this._modalUniqueId) {
      this.doClose(event);
    }
  }

  render() {

    var modalStyle;

    if (this.props.unstyled) {
      modalStyle = {};
    
    } else {
      modalStyle = extend({}, styles.modal, this.props.modalStyle);
    }
    // If no transition is provided then passthrough component
    const Transition = this.props.transition || IdentityComponent;

    if (!this.props.show) {
      return null;
    }

    const baseModalUiProps = {
      modalId: this._modalUniqueId,
      modalStyle: modalStyle,
      isClosing: this.props.isClosing || this.state.isClosing,
      isShaking: this.state.shaking,
      style: this.props.style,
      className: this.props.className,
      children: this.props.children,
      Transition: Transition,
      onOuterClick: this.handleOuterClick
    };
    
    return createPortal(
      (
        this.props.shouldTrapFocus ?
          <FocusTrap>
            <BaseModalUi { ...baseModalUiProps } />
          </FocusTrap>
        :
          <BaseModalUi { ...baseModalUiProps } />
      ),
      window.document.body
    );
  }
}


BaseModal.propTypes = {
  closeOnOuterClick: PropTypes.bool,
  // The function to call when the modal wants to close itself
  onRequestClose: PropTypes.func.isRequired,
  // How long to wait until isClosing the modal
  // useful for transitions
  closeTimeout: PropTypes.number,
  isClosing: PropTypes.bool,
  style: PropTypes.object,
  show: PropTypes.bool
};

BaseModal.defaultProps = {
  closeOnOuterClick: true,
  closeTimeout: 0,
  isClosing: false,
  show: true,
  shouldTrapFocus: false
};


export default BaseModal;
